import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { accountSettingsRoute } from 'src/app/app-routing.module';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { AccountPrivileges } from '../../account-details/models/account-privileges';
import { AccountOrderingOptions, AccountRegisterOptions } from '../models/account-register-options';
import { AccountRegisterListItem } from '../models/account-register-results.model';
import { selectQuickFilters } from '../state/account-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-register-view',
    styleUrls: ['./account-register-view.component.scss'],
    templateUrl: './account-register-view.component.html',
    standalone: false
})
export class AccountRegisterViewComponent extends EntityRegisterView<
   AccountRegisterListItem,
   AccountRegisterOptions,
   AccountOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => AccountRegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() includeInactive: boolean;

   @Input() accountPrivileges: AccountPrivileges;

   @Output() showAllAccountsChanged = new EventEmitter<boolean>();

   @Output() resetMwi = new EventEmitter<any>();

   isLcsInternalOptions = ['All Accounts', 'Internal Accounts Only', 'Customer Accounts Only'];

   selectedInternalOption: string;

   showElevatedLogLevel: boolean;

   protected override onQuickFiltersInit(quickFilters: AccountRegisterOptions): void {
      this.includeInactive = quickFilters.showAllAccounts ?? false;
      this.selectedInternalOption = quickFilters.internalOptions ?? 'All Accounts';
      this.showElevatedLogLevel = quickFilters.searchByLogLevel ?? false;
   }

   getRouterLink(id: number) {
      return `/${accountSettingsRoute}/${id}`;
   }

   showAllAccountsChange(showAllAccountsSelected: boolean): void {
      this.registerOptions = { ...this.registerOptions, showAllAccounts: showAllAccountsSelected };
      this.quickFilterChange.emit(this.registerOptions);
      this.showAllAccountsChanged.emit(showAllAccountsSelected);
   }

   searchByLogLevelChange(searchByLogLevelSelected: boolean): void {
      this.quickFilterChange.emit({ ...this.registerOptions, searchByLogLevel: searchByLogLevelSelected });
   }

   internalOptionsChange(internalOptionsSelected: string): void {
      this.quickFilterChange.emit({ ...this.registerOptions, internalOptions: internalOptionsSelected });
   }

   onResetMwiClick(): void {
      this.resetMwi.emit();
   }
}
